export default function management ($) {

    if ($("body").hasClass("page-template-page-about") || $("body").hasClass("single-producer") ) {

        // Hide and show the entire managment section by toggling the 'team-toggle' link
        
        $('.team-toggle').on('click', function(){
            $('.section-management').hasClass('hide-team')? 
                $('.section-management').removeClass('hide-team'): 
                $('.section-management').addClass('hide-team');           
        })     

        //  Hide and show individual person bio cards

        let card = $('.person-card');

        $( ".person-card-small" ).click(function() {
            let thisCard = $(this).closest('.person-card');
            
            card.not(thisCard).addClass('bio-hidden')

            thisCard.removeClass('bio-hidden')
            $('.close-bar-1').removeClass('rotate-1');
            $('.close-bar-2').removeClass('rotate-2');

          });

          $( ".card-close" ).click(function() {
            $('.close-bar-1').addClass('rotate-1');
            $('.close-bar-2').addClass('rotate-2');
       
            let thisCard = $(this).closest('.person-card');
            thisCard.addClass('bio-hidden')

          });
       
    }



}
